/*eslint-disable */
import Vue from 'vue'
import moment from 'moment';

Vue.filter('dateformat', (arg) => {
  return moment(arg).format('MMMM DD YYYY')
})
Vue.filter('UTCDateFormat', (arg) => {
  return moment(arg).utc().format('DD')
})
Vue.filter('UTCYearFormat', (arg) => {
  return moment(arg).utc().format('YYYY')
})
Vue.filter('UTCMonthFormat', (arg) => {
  return moment(arg).utc().format('MMMM')
})
Vue.filter('UTCMonthIntegerFormat', (arg) => {
  return moment(arg).utc().format('M')
})
Vue.filter('onlydateformat', (arg) => {
  return moment(arg).format('DD')
})
Vue.filter('onlymonthformat', (arg) => {
  return moment(arg).format('MMMM')
})
Vue.filter('yearformat', (arg) => {
  return moment(arg).format('YYYY')
})
Vue.filter('timeformat', (arg) => {
  return moment(arg).format('h:mm:ss a')
})
Vue.filter('hourstimeformat', (arg) => {
  return moment(arg).format('h:mm a')
})
Vue.filter('secondDateFormat', (arg) => {
  return moment(arg).format('DD MMMM YYYY')
})